import { webApi } from "../../../../core/http/httpThunks";

export const deleteOrderIndApi = (userId: string, ordindid: number) =>
  webApi<string>({
    method: "DELETE",
    url: "order/deleteorderindicative",
    params: {
      userId,
      ordindid,
    },
  });

export default deleteOrderIndApi;
